import { S3Client } from '@aws-sdk/client-s3';

export interface S3Item<T> {
  data: T;
  lastModified: Date | undefined;
}

// ===== S3 Cache =====

// 함수로 만들어 매번 환경변수를 읽도록 함 (ES modules 호이스팅 문제 해결)
export const getBucketName = () => {
  const bucket = process.env.AWS_S3_BUCKET_NAME;
  return bucket;
};

export const getS3Region = () => {
  return process.env.AWS_REGION;
};

export const getS3CacheUrl = (key: string) => {
  const cdnDomain = process.env.NEXT_PUBLIC_AWS_S3_CACHE_CDN_DOMAIN;
  return `https://${cdnDomain}/${key}`;
};

export const getS3CacheToken = () => {
  return process.env.AWS_S3_CACHE_ACCESS_TOKEN;
};

// 실제로 클라이언트에서는 실행될 일이 없지만 해당 모듈이 브라우저로 import 될 때 에러를 발생시킴
// 이를 방지하기 위해 lazy initialization로 실제 사용 시에만 생성하도록 함

let _getS3Client: S3Client | null = null;

export const getS3Client = () => {
  if (_getS3Client) {
    return _getS3Client;
  }
  const region = process.env.AWS_REGION;
  const accessKeyId = process.env.AWS_ACCESS_KEY_ID;
  const secretAccessKey = process.env.AWS_SECRET_ACCESS_KEY;

  if (!region || !accessKeyId || !secretAccessKey) {
    throw new Error(
      'AWS_REGION, AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY가 설정되지 않았습니다.',
    );
  }

  _getS3Client = new S3Client({
    region,
    credentials: {
      accessKeyId,
      secretAccessKey,
    },
  });
  return _getS3Client;
};
